export default __webpack_public_path__ + "media/images/mailer/icon_person_add-4454ddab5e30b3d4a514d4cf6eb4f402.png";